import CustomersPage from '@/pages/shared/CustomersPage'

/** Sales browses customers and adds walk-ins, but cannot suspend an account, touch a wallet, set a tier or sign in as anyone. */
export default function SalesCustomers() {
  return <CustomersPage basePath="/sales" canSuspend={false} canAdjustWallet={false} canSignInAs={false} canSetTier={false} canSetPassword={false} />
}
